import { BasicPermissionItem } from '../../PermissionItem'
import {
  EditPackageNumberName,
  GiveDisposition,
  Revert,
  Simple,
  Unlock,
  CreateViewEditSoftRemoveRestore,
} from '../../common'
import { DSLog } from '../../../cimsPage/instances/ds'
import { DSStatus } from '../../../statuses/ds'
const { DisciplineAction } = DSStatus

const object = 'Design Submittal'
const page = DSLog
const ds = CreateViewEditSoftRemoveRestore({
  object,
  page,
  create: '3c27d640-dc68-48fb-ba78-7d6a72c32d1b',
  view: 'bb2f177d-797f-4714-844c-1e67fad97dbb',
  edit: 'cf41f91e-82a3-472e-8d5e-8b52152cb346',
  removeRestore: 'dc0f7162-dd4d-4640-8e98-42c2edcbd9a5',
})
export const CreateDesignSubmittal = ds.Create
export const ViewDesignSubmittal = ds.View
export const EditDesignSubmittal = ds.Edit
export const RemoveRestoreDesignSubmittal = ds.RemoveRestore

export const RouteDesignSubmittal = Simple({
  id: 'b80e4d46-6898-4922-b6ce-3a53bfb4efaf',
  action: 'Route',
  object,
  page,
})

export const ReviewAllDesignSubmittal = new BasicPermissionItem({
  id: 'cd686dae-8d13-40e7-876d-8e5f6e51afa4',
  page,
  name: 'Review All Disciplines',
  action: `check all boxes during ${DisciplineAction.name}`,
  allowMixedCase: true,
})

export const CommentOnDesignSubmittal = Simple({
  id: 'ea6134f4-f8ca-4ed6-8448-4ee11e764db5',
  action: 'Comment on',
  object,
  page,
})

export const EditNumberNameDesignSubmittal = EditPackageNumberName({
  id: '19daf251-4470-4fd2-94c8-60915273d8b0',
  object,
  page,
})

export const GiveDispositionDesignSubmittal = GiveDisposition({
  id: '5abb92c6-13d1-4b6c-b134-3c42a98015c3',
  object,
  page,
})

export const RevertDesignSubmittal = Revert({
  id: '053976d6-282c-40f1-bcbc-d93bff9a71eb',
  object,
  page,
})

export const UnlockDesignSubmittal = Unlock({
  id: '85019301-a178-40ea-82e9-ab6e80235967',
  object,
  page,
})

export type DSLogPermission =
  | typeof CreateDesignSubmittal
  | typeof ViewDesignSubmittal
  | typeof EditDesignSubmittal
  | typeof RemoveRestoreDesignSubmittal
  | typeof RouteDesignSubmittal
  | typeof ReviewAllDesignSubmittal
  | typeof CommentOnDesignSubmittal
  | typeof EditNumberNameDesignSubmittal
  | typeof GiveDispositionDesignSubmittal
  | typeof RevertDesignSubmittal
  | typeof UnlockDesignSubmittal
